import { render, staticRenderFns } from "./AllLandingProducts.vue?vue&type=template&id=0fa17930&scoped=true"
import script from "./AllLandingProducts.vue?vue&type=script&lang=ts"
export * from "./AllLandingProducts.vue?vue&type=script&lang=ts"
import style0 from "./AllLandingProducts.vue?vue&type=style&index=0&id=0fa17930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa17930",
  null
  
)

export default component.exports